import * as React from "react";
const SvgClient = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={50}
    height={50}
    fill="none"
    {...props}
  >
    <g clipPath="url(#demo_svg__a)">
      <path fill="#fff" d="M0 0h50v50H0z" />
      <path
        fill="#68ACFF"
        d="M50 41.54c-.827 1.687-2.135 2.327-3.946 2.189-1.584-.12-3.181-.025-4.861-.025-.186-6.83 1.082-13.846-4.175-19.248C40.71 20.664 47.436 22.62 50 28.128v13.41zM24.578 47.003c-2.92 0-5.84.015-8.76-.004-2.625-.017-3.987-1.378-4.005-4.106-.02-2.889-.152-5.803.14-8.664.684-6.688 4.305-10.53 10.74-11.404 5.43-.737 10.295.367 13.571 5.54 1.27 2.006 1.89 4.226 1.94 6.603.055 2.638.059 5.278.011 7.916-.047 2.644-.915 3.815-3.427 3.957-3.394.194-6.806.048-10.21.048v.115zM33.477 10.393c.016 4.952-3.763 8.905-8.498 8.888-4.68-.015-8.419-3.92-8.43-8.803-.011-4.96 3.755-8.9 8.494-8.885 4.667.014 8.417 3.925 8.434 8.8M13.133 24.336C7.796 29.9 8.981 36.886 8.847 43.665c-2.234 0-4.364.093-6.482-.034-1.343-.08-2.304-1.345-2.32-2.875-.039-3.852-.085-7.709.017-11.56.086-3.175 2.362-5.797 5.387-6.27 2.61-.409 5.227-.521 7.686 1.41zM42.12 19.28c-2.977-.037-5.341-2.587-5.285-5.698.055-3.03 2.465-5.51 5.351-5.51 2.927 0 5.395 2.597 5.376 5.655-.02 3.084-2.475 5.587-5.442 5.55zM7.673 19.276c-2.898-.084-5.247-2.625-5.21-5.639.04-3.065 2.566-5.641 5.46-5.564 2.957.077 5.335 2.675 5.267 5.752-.068 3.105-2.53 5.536-5.517 5.451"
      />
    </g>
    <defs>
      <clipPath id="demo_svg__a">
        <path fill="#fff" d="M0 0h50v50H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClient;